import React, { Component } from "react";
import "./Footer.css";

class Footer extends Component {
    render() {
        return (
            <div className="footer">
                <div style={{ height: "50%", margin: "auto" }}>
                    <img className="footer-logo" src="./logo.png" alt="Artblast AI logo" />
                    <div style={{ color: "white", fontSize: "10px", textAlign: "center" }}>by SciFork SARL</div>
                </div>
            </div>
        );
    }
}

export default Footer;